import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/receivebles/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllAdjustTypes: config.endpoints.backend + 'adjusttypes/getall',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointDelete: `${config.endpoints.backend}receivebles/delete`,
        endpointGetAllResourceSource: config.endpoints.backend + 'resourcesources/getall',
        endpointGetAllProjectUnits: config.endpoints.backend + 'projectunits/getall',
        endpoint: config.endpoints.backend + 'receivebles/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_entity_id ? {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4,
            } : {},
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'pdc_resource_source_id',
                type: 'select',
                label: 'Origem de Recurso',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllResourceSource,
                    label: 'description',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4,
            },
            {
                name: 'isInstallment',
                type: 'select',
                label: 'Parcelado',
                isClearable: true,
                options: [
                  { label: 'Sim', value: '1' },
                  { label: 'Não', value: '0' }
                ],
                validations: {
                  required: false
                },
                columnSize: 3
            },
            {
                name: 'period',
                name_start: 'date_start',
                name_end: 'date_end',
                type: 'date_period',
                label: 'Data',
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Contas a Receber',
        labelTitleButtonAdd: 'Incluir nova conta a receber',
        fieldsShowOnDelete: ['project','predicted_value'],
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'project',
                label: 'Projeto'
            },{
                name: 'predicted_value',
                label: 'Valor Total'
            },
            {
                name: 'issue_date',
                label: 'Data de Emissão'
            },
            {
                name: 'due_date',
                label: 'Data de Valiadde'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
